import { Building2 } from "lucide-react";

const chip = (on) => `px-2.5 py-1 rounded-md text-xs font-semibold border transition-colors ${on ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-700 border-slate-300 hover:border-slate-500"}`;

// Yıl (tek) + Firma (tek ya da çoklu) filtreleri
export default function FinFilters({ years, year, setYear, companies, selected, setSelected }) {
  const toggle = (c) => setSelected(selected.includes(c) ? selected.filter((x) => x !== c) : [...selected, c]);
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="fin-filters">
      <label className="flex items-center gap-2 text-xs font-semibold text-slate-600">Yıl
        <select value={year} onChange={(e) => setYear(e.target.value)} className="px-2.5 py-1.5 text-xs border border-slate-300 rounded-md bg-white" data-testid="fin-filter-year">
          <option value="">Tümü</option>
          {years.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      </label>
      <div className="flex flex-wrap items-center gap-1.5">
        <Building2 className="w-3.5 h-3.5 text-slate-500" />
        <button type="button" onClick={() => setSelected([])} className={chip(selected.length === 0)} data-testid="fin-filter-company-all">Tüm Firmalar</button>
        {companies.map((c) => <button key={c} type="button" onClick={() => toggle(c)} className={chip(selected.includes(c))} data-testid={`fin-filter-company-${c}`}>{c}</button>)}
        {companies.length === 0 && <span className="text-xs text-slate-400">Henüz firma yok — ilk beyannameyi yükleyin</span>}
      </div>
    </div>
  );
}
